const lang = {
    actionButton: {
        confirm: '確認',
        cancel: 'キャンセル',
    },
};
export default lang;
